<template>
    <div class="load_error_card">
        <el-empty class="empty-warp"  :description="`数据加载失败，请点击重试(${errMsg})`" :image-size="100">
            <el-button type="primary" @click="retry">重试</el-button>
        </el-empty>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const emit = defineEmits(['retry'])
const props = defineProps({
    msg:{
        type:[String,Number],
        default:''
    }
})
const errMsg = computed(()=>{
    return props.msg.toString().includes('AxiosError') ? '网络繁忙' : props.msg
})

const retry = ()=>{
    emit('retry')
}
</script>

<style lang="less" scoped>
.load_error_card{
    
}
</style>